export default __webpack_public_path__ + "images/bfd1eff24d1a89a2b5c0ce4099ed48ea.png";